import type { Reactive } from 'vue'

/**
 * The general system state, not related to a specific user request.
 * Typically the same throughout a single session.
 */
export type AppContext = {
  languagePrefix: string | undefined
  partnerId: PartnerId | undefined
  persistentParams: object | undefined
}

export function useAppContext(): Reactive<AppContext> {
  const params = useParams()
  const partner = usePartner()
  const confData = useConfdata()

  return reactive({
    languagePrefix: computed(() => confData.languagePrefix),
    partnerId: computed(() => partner.id),
    persistentParams: computed(() => params.persistent),
  })
}
